import MissionsTutorialLayer from './MissionsTutorialLayer';
import { connect } from 'react-redux';

const mapStateToProps = state => {
  return {
    tutorial: state.tutorial,
    gameId: state.gameInfo.gameId,
    missionsAssets: state.assetsPackage.assets.MISSIONS_FEATURE,
  };
};

export default connect(mapStateToProps)(MissionsTutorialLayer);

